import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { DoctorService } from '../../_service/doctor.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
declare var $: any;
import { HospitalService } from '../../_service/hospital.service';
import { ConfirmationModalComponent } from '../../common/confirmation-modal/confirmation-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-add-editdoctors',
  templateUrl: './add-editdoctors.component.html',
  styleUrls: ['./add-editdoctors.component.css']
})
export class AddEditdoctorsComponent implements OnInit {
    @ViewChild('thVidInp') thvidVariable: ElementRef;
    @ViewChild('fVidInp') fvidVariable: ElementRef;

  doctorForm: FormGroup;submitted = false;loading:boolean=false;cities=[];passwordhide:boolean = true;DoctorId: any = '';uploading:boolean=false;myrole:string='';
  allUploads=[];s3url='';doc_type:string='';doc_file:string='';circles=[];doctor_city:boolean=true;circles_copy=[];cities_copy=[];doctorName:string;TreatmentcostList=[];activeTab='0';treatmentcost:boolean=false;treatmentcostId:any;treatmentcostForm: FormGroup;treatments=[];treatments_copy=[];treatCategory=[];location=[];doctor_location:boolean=true;treatment_select:boolean=true;
  doctorDiariesForm: FormGroup;submittedDiaries = false;loadingDiaries:boolean=false;diaryId: any = '';doctorDiaryList=[];thumbnail_video='';full_video='';fileDeletingLoader:boolean=false;language_speak:any;languageData:any;services=[]; services_copy=[];locality=[];locality_copy=[];FeaturSpecialty=[];disableSelect: any = [];
  hospitals=[];hospitals_copy=[];available_hospital_id:any; available_hospital_Data:any;
  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;fileDeleting:boolean = false;

    constructor(private hospitalapi:HospitalService,private doctorapi:DoctorService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,public leadapi:LeadsService,private activatedRoute: ActivatedRoute,public miscapi:MiscService,private dialog: MatDialog)
    {   
        this.getFeaturedSpecialties();
        this.getcircle();
        //this.getTreatment();
        this.getTreatmentCategory();
        this.getServices();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
        let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
        let passwordPattern = "^[a-zA-Z0-9]{8,}$";

        this.doctorDiariesForm = this.formBuilder.group({ 
            'title' : [null, Validators.required],
            'thumbnail_video_url': [null],
            'video_url': [null],
            'description' : [null],
            'status' :[null, Validators.required]
        });

        this.treatmentcostForm = this.formBuilder.group({ 
            'treatment_id' : [null, Validators.required],
            'price' : [null, Validators.required],
            'doctor_id': [null]
        });

        this.doctorForm = this.formBuilder.group({ 
            'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
            'email': [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
            'name' : [null, Validators.required],
            'status' : [null, Validators.required],
            'gender' : [null],
            'circle_id' : [null, Validators.required],
            'city_id' : [null, Validators.required],
            'password': [null, Validators.compose([Validators.required, Validators.pattern(passwordPattern)])],
            'qualification' : [null],
            'specialist' : [null],
            'work_exp' : [null],
            'review' : [null],
            'detail' : [null],
            'membership' : [null],
            'education' : [null],
            'altphone' : [null],
            'image':[null],
            'catergory_id':[null, Validators.required],
            'about_us':[null],
            'treatment_ids':[null],
            'location_ids':[null],
            'practo_rating':[null],
            'language_known':[null],
            'featured_specialty':[null],
            'doctor_type':[null],
            'google_rating':[null],
            'zone':[null],
            'address':[null],
            'pincode':[null],
            'latitude':[null],
            'longitude':[null],
            'online_consultation_fees':[null],
            'offline_consultation_fees':[null],
            'services_ids':[null],
            'localities_id':[null],
            'is_glamyo_verified':[null],
            'display_number':[null],
            'ranking':[null],
            'physical_location':[null],
            'additional_location': this.formBuilder.array([]),
            'online_max_fee':[null],
            'online_sale_fee':[null],
            'physical_max_fee':[null],
            'physical_sale_fee':[null],
            'available_hospital':[null]
        });

        this.activatedRoute.params.subscribe(params => {
            if (params['doctor_id']) {
                this.DoctorId = params['doctor_id'];
                this.patchDoctorData();
                this.getDoctorTreatmentcostList();
                this.getDoctorDiariesList();
                const userPass = this.doctorForm.get('password');
                userPass.clearValidators();
                userPass.updateValueAndValidity();
            }

        });

        

    }

    get f() { return this.doctorForm.controls; }
    get t() { return this.treatmentcostForm.controls; }
    get d() { return this.doctorDiariesForm.controls; }

    async addDoctorDiaries(){
        this.submittedDiaries = true;
        this.loadingDiaries = true;
        // stop here if form is invalid
        if (this.doctorDiariesForm.invalid) {
            this.loading = false;
            return;
        }
        
        //For Update Doctor...//
        if(this.DoctorId){
            if(this.diaryId){
                this.doctorDiariesForm.value.id= parseInt(this.diaryId); 
            }   
        
            this.doctorDiariesForm.value.doctor_id= parseInt(this.DoctorId); 
            await this.doctorapi.updateDoctorDiaries(this.doctorDiariesForm.value)
            .subscribe((data:any) => {
                this.submittedDiaries = false;
                this.loadingDiaries = false;
                if(data.status)
                {
                    this.resetDiaryForm();
                    this.getDoctorDiariesList();
                    this.sharedapi.presentToast(data.msg);
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
            }, error => 
            {
                this.sharedapi.checkError(error);
            });  
        }
    }

    selectDiariesVideo(event,type)
    {
        const file = (event.target as HTMLInputElement).files[0];
        if(type == '1'){
           this.doctorDiariesForm.patchValue({
            thumbnail_video_url: file
            });
        }else{
            this.doctorDiariesForm.patchValue({
            video_url: file
            });
        }
    }

    

    setSearchValue(type){
        if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='city'){
            $("#citySearch").val('');
            $("#citySearch").focus();
            this.cities= this.cities_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='localities'){
            $("#localitiesSearch").val('');
            $("#localitiesSearch").focus();
            this.locality= this.locality_copy;
        }else if(type=='available_hospital'){
            $("#available_hospitalSearch").val('');
            $("#available_hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='services'){
            $("#servicesSearch").val('');
            $("#servicesSearch").focus();
            this.services= this.services_copy;
        }
        
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment(catergory_id)
    {
        let qString = 'catergory_id='+catergory_id;
        await this.leadapi.getTreatmentCategorywise(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
                this.treatment_select=false;
            }else{
                this.treatments = [];
                this.treatment_select=true;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getCitiesLocation(city_id)
    {   
        let qString = 'city_id='+city_id;
        await this.leadapi.getLocations(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.location = data.data;
                this.doctor_location=false;
                
            }else{
                this.location = [];
                this.doctor_location=true;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getFeaturedSpecialties()
    {
        await this.doctorapi.get_Featured_Specialties().subscribe((data:any) => {
            if(data.status)
            {
                this.FeaturSpecialty = data.data;
            }else{
                this.FeaturSpecialty = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else if(type == 'cities'){
            this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else if(type == 'localities'){
            this.locality = this.sharedapi.searchData(searchtText, this.locality_copy, "name");
        }else if(type == 'available_hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'services'){
            this.services = this.sharedapi.searchData(searchtText, this.services_copy, "name");
        }
    }


    selectProfilePic(event)
    {
        const file = (event.target as HTMLInputElement).files[0];
        this.doctorForm.patchValue({
          image: file
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    

    async getCircleCities(circle_id)
    {
        this.getCircleHospital(circle_id);
        let qString = 'circle='+circle_id;
        await this.doctorapi.getCircle_cities(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
                this.cities_copy = this.cities;
                this.doctor_city=false;
            }else{
                this.cities = [];
                this.doctor_city=false;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });

        
    }
    async getCircleHospital(circle_id)
    {
        let qString = 'circle='+circle_id;
        await this.doctorapi.getCircle_wise_hospital(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy = this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    ngOnInit(): void 
    {
        this.s3url = localStorage.getItem('s3url');  
        this.getLocality();
    }

    
    showPassword() {
        this.passwordhide = !this.passwordhide;
    }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            let file = event.target.files.item(0);
            const formData = new FormData();  
            formData.append('upload_type',this.doc_type)
            formData.append('file', file); 
            await this.doctorapi.uploadDoctorFile(this.DoctorId,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.patchDoctorData();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error => 
                {
                    this.uploading = false;
                    this.sharedapi.checkError(error);
                });
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }

    async patchDoctorData(){
        
        await this.doctorapi.getDoctorData(this.DoctorId).subscribe((response:any) => {
           if(response.status){
            console.log(response)
            this.language_speak= response.data.language_known;
            if (this.language_speak) {
                 this.languageData = this.language_speak .split(',');
              } 
            this.available_hospital_id= response.data.available_hospital;
            if (this.available_hospital_id) {
                this.available_hospital_Data = this.available_hospital_id .split(',');
            } 
            this.DoctorId = response.data.id;
           
            this.doctorapi.SharingData.next(this.DoctorId);
              
            this.getCircleCities(response.data.circle_id);
            this.getCircleHospital(response.data.circle_id);
            this.getCitiesLocation(response.data.city_id);
            if(response.data.assigenedTreatmentCatergory){
                this.getTreatment(response.data.assigenedTreatmentCatergory.join(','))
            }
            let locationsIds;
            if(response.data.assigenedDocLocations){
                locationsIds = response.data.assigenedDocLocations.toString();
            }
            
            this.allUploads = response.uploads;
               this.doctorForm.patchValue({
                 'name':response.data.name,  
                 'mobile':response.data.mobile,  
                 'email':response.data.email,  
                 'qualification':response.data.qualification,  
                 'review':response.data.review,  
                 'specialist':response.data.specialist,  
                 'status':response.data.status,  
                 'gender':response.data.gender,  
                 'membership':response.data.membership,  
                 'mci':response.data.mci,  
                 'education':response.data.education,  
                 'detail':response.data.detail,  
                 'city_id':response.data.city_id,
                 'circle_id':response.data.circle_id,   
                 'altphone':response.data.altphone,
                 'work_exp':response.data.work_exp,
                 'about_us':response.data.about_us,
                 'catergory_id':response.data.assigenedTreatmentCatergory,
                 'google_rating':response.data.google_rating,
                 'practo_rating':response.data.practo_rating,
                 'language_known':this.languageData,
                 'featured_specialty':response.data.featured_specialty,
                 'doctor_type':response.data.doctor_type,
                 'treatment_ids':response.data.assigenedDocTreatments,
                 'location_ids':locationsIds,
                 'zone':response.data.zone,
                 'address':response.data.address,
                 'pincode':response.data.pincode,
                 'latitude':response.data.latitude,
                 'longitude':response.data.longitude,
                 'online_consultation_fees':response.data.online_consultation_fees,
                 'offline_consultation_fees':response.data.offline_consultation_fees,
                 'services_ids':response.data.services,
                 'localities_id':response.data.localities_id,
                 'is_glamyo_verified':response.data.is_glamyo_verified,
                 'display_number':(response.data.display_number == 0 ? "" : response.data.display_number),
                 'ranking':response.data.ranking,
                 'physical_location':response.data.physical_location,
                 'online_max_fee':response.data.online_max_fee,
                 'online_sale_fee':response.data.online_sale_fee,
                 'physical_max_fee':response.data.physical_max_fee,
                 'physical_sale_fee':response.data.physical_sale_fee,
                 'available_hospital':this.available_hospital_Data

               })

                if (response.data.additional_location) {
                    let controlArray = this.doctorForm.get('additional_location') as FormArray;
                    response.data.additional_location.forEach((element, index) => {
                        controlArray.push(this.formBuilder.group({
                            hospital_id: element.hospital_id.toString(),
                            timing: element.timing
                        }));
                    });
                }
               this.doc_type='';
               this.doc_file='';
               this.doctorName= response.data.name;
              
           }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async createDoctor(){
        console.log(this.doctorForm.value);
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.doctorForm.invalid) {
            this.loading = false;
            return;
        }
        //For Update Doctor...//
        if(this.DoctorId){
        this.doctorForm.value.id= parseInt(this.DoctorId); 
        await this.doctorapi.updateDoctor(this.doctorForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Doctor Update Successfully');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });  
        }else{ 
            //For Add Doctor//
          await this.doctorapi.addDoctor(this.doctorForm.value)
         .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.router.navigateByUrl('/update-doctor/'+data.lastId);
                this.sharedapi.presentToast('Doctor Added Successfully');
                this.DoctorId= data.lastId;
                this.patchDoctorData();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
        }
    }

    // Treatment Cost//
    async getDoctorTreatmentcostList(){
        await this.doctorapi.getTreatmentcostList(this.DoctorId).subscribe((data:any) => {
            if(data.status)
            {
                this.TreatmentcostList = data.data;
            }else{
                this.TreatmentcostList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    // Treatment Cost//
    async getDoctorDiariesList(){
        await this.doctorapi.getDoctorDiariesList(this.DoctorId).subscribe((data:any) => {
            if(data.status)
            {
                this.doctorDiaryList = data.data;
            }else{
                this.doctorDiaryList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    resetForm(){
        this.treatmentcost=false;
        this.submitted=false;
        this.treatmentcostForm.reset();
    }

    resetDiaryForm(){
        this.diaryId='';
        this.submittedDiaries=false;
        this.thumbnail_video = '';
        this.full_video = '';
        this.thvidVariable.nativeElement.value = "";
        this.fvidVariable.nativeElement.value = "";
        this.doctorDiariesForm.reset();
    }

    fetchTreatCostData(id){
        this.treatmentcostId=id;
        this.doctorapi.getTreatCostData(id).subscribe((response:any) => {
            if(response.status){
                this.treatmentcost=true;
                this.treatmentcostForm.patchValue({
                    'treatment_id':response.data.treatment_id,
                    'price':response.data.price
                })
            }
            
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    fetchDoctorDiaryData(id)
    {
        this.diaryId = id;
        this.doctorapi.getDoctorDiaryData(id).subscribe((response:any) => {
            if(response.status){
                this.doctorDiariesForm.patchValue({
                    'title':response.data.title,
                    'description':response.data.description,
                    'status':response.data.status,
                });
                this.thumbnail_video = response.data.thumbnail_video_link;
                this.full_video = response.data.full_video_link;
            }
            
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    removeFile(diaryId, file_type)
    {
        /* console.log(diaryId); */
        this.fileDeletingLoader = true;
        this.doctorapi.deletedoctordiariesfiles(diaryId, file_type).subscribe((data:any) => {
            this.fileDeletingLoader = false;
            if(data.status)
            {
                if(file_type == 'full_video')
                {
                this.full_video = '';
                }
                if(file_type == 'thumbnail_video')
                {
                this.thumbnail_video = '';
                }
                this.getDoctorDiariesList();
            }
            this.sharedapi.presentToast(data.msg);
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async createDoctorTreatcost(){
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.treatmentcostForm.invalid) {
            this.loading = false;
            return;
        }
        this.treatmentcostForm.value.doctor_id= parseInt(this.DoctorId); 
        if(this.treatmentcost){
            this.treatmentcostForm.value.id= parseInt(this.treatmentcostId); 
                await this.doctorapi.updateTreatmentCost(this.treatmentcostForm.value)
                .subscribe((data:any) => {
                this.submitted = false;
                this.loading = false;
                    if(data.status)
                    {
                        this.sharedapi.presentToast('Treatment Cost Updated Successfully');
                        this.getDoctorTreatmentcostList();
                    }
                    else
                    {
                        this.sharedapi.presentToast(data.msg);
                    }
                }, error => 
                {
                    this.sharedapi.checkError(error);
                });  
        }else{
            await this.doctorapi.addTreatmentCost(this.treatmentcostForm.value)
                .subscribe((data:any) => {
                this.submitted = false;
                this.loading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('Treatment Cost Added Successfully');
                    this.getDoctorTreatmentcostList();
                    this.activeTab='1'; 
                    this.treatmentcostForm.reset();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
                }, error => 
                {
                    this.sharedapi.checkError(error);
                }); 
            }
        
    }

    async getServices()
    {
        await this.miscapi.getServices().subscribe((data:any) => {
            if(data.status)
            {
                this.services = data.data;
                this.services_copy = this.services;
            }else{
                this.services = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLocality()
    {
        await this.hospitalapi.getLocalities().subscribe((data:any) => {
            if(data.status)
            {
                this.locality = data.data;
                this.locality_copy =this.locality;
            }else{
                this.locality = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    addOtherLocation(): FormArray {
        return this.doctorForm.get("additional_location") as FormArray
    }
    
    newQuantity(): FormGroup {
        return this.formBuilder.group({
            hospital_id: '',
            timing: ''
            // other_location: '',
            // other_address: '',
            // other_latitude: '',
            // other_longitude: ''
        })
    }
    
    addQuantity() {
    this.addOtherLocation().push(this.newQuantity());
    let getIndex = this.doctorForm.controls["additional_location"].value.length - 1;
    this.disableSelect[getIndex] = true;
    }
    
    removeQuantity(i: number) {
    this.addOtherLocation().removeAt(i);
    }

 //-----------------------------------Delete doctor document Data---------------------------------------//
 RemoveDoc(doc_id) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '350px',
      backdropClass: 'backdropBackground',
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          ok: 'Confirm',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let data = {
          'id': doc_id
        }
        this.doctorapi.deleteDocuments(data).subscribe((data: any) => {
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast(data.msg);
            this.patchDoctorData();
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

      }
    });
  }

}
